import { useNotification } from "components/Notification/useAddNotification";

export const useCancelUserAppointmentNotification = () => {
  const { addNotification } = useNotification();

  const notificationTitle = "Anulowanie rezerwacji";

  const showSuccessNotification = () =>
    addNotification({
      title: notificationTitle,
      description: "Pomyślnie anulowano rezerwację",
      type: "success",
    });

  const showErrorNotification = () =>
    addNotification({
      title: notificationTitle,
      description: "Coś poszło nie tak i nie udało się anulować rezerwacji",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
